import React from 'react';
import ReactOnRails from 'react-on-rails';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  HashRouter
} from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../store';

import {
  setUser,
  setAffiliate,
  setEnvironment,
  setReferral,
  setProducts,
  setArrivalTimes,
  setCountryCode,
  setLocalProfileElements,
  setRegistered,
  setGuestKind,
  setGuestKindUnknownPlace,
  setVaccinationOptions,
  setVaccinationInfo,
  setOnshore
} from '../actions';
import {
  setAddress,
  setActiveProfileElements,
  setContent,
  setEthnicityOptions,
  setLanguageOptions,
  setPage,
  setPages,
  setProfileElements,
  setRequiredFields,
  setTerritory,
  setRecaptchaSiteId,
  setVaccinationMandatory,
  setAuthenticatedUser
} from '../../../shared/actions';
import { IntlProvider } from 'react-intl';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import { translations } from '../../../libs/i18n/translations';
import { defaultLocale } from '../../../libs/i18n/default';
import Routes from '../routes/routes';
import Layout from '../layout/Layout';

const locale = defaultLocale;
const messages = translations[locale];
const dispatch = store.dispatch

addLocaleData([...en, ...fr]);

class GuestSignUp extends React.Component {
  constructor(props) {
    super(props);

    dispatch(setAddress(props.address))

    dispatch(setTerritory(props.territory))

    dispatch(setUser(props.user))

    dispatch(setEnvironment(props.environment))

    dispatch(setAffiliate(props.affiliate))

    dispatch(setReferral(props.referral))

    dispatch(setProducts(props.products))

    dispatch(setRequiredFields(props.required_fields))

    dispatch(setLanguageOptions(props.language_options))

    dispatch(setEthnicityOptions(props.ethnicity_options))

    dispatch(setArrivalTimes(props.arrival_times))

    dispatch(setRegistered(props.registered))

    dispatch(setPage(props.page))

    dispatch(setProfileElements(props.profile_elements))

    dispatch(setLocalProfileElements(props.local_profile_elements))

    dispatch(setContent(props.content))

    dispatch(setGuestKind(props.guest_kind))

    dispatch(setGuestKindUnknownPlace(props.guest_kind_unknown_place))

    dispatch(setPages(props.pages))

    dispatch(setVaccinationMandatory(props.vaccination_mandatory))

    dispatch(setVaccinationOptions(props.vaccination_options))

    dispatch(setVaccinationInfo(props.vaccination_details))

    dispatch(setOnshore(props.onshore))

    dispatch(setRecaptchaSiteId(props.recaptcha_site_id))

    dispatch(setAuthenticatedUser(props.authenticated_user))
  }
  render() {
    return (
      <Provider store={store}>
        <Layout user={this.props.user} territory={this.props.territory} page={this.props.page}>
          <HashRouter>
            {Routes}
          </HashRouter>
        </Layout>
      </Provider>
    );
  }
}

export default GuestSignUp;
